<label
  class="dropdown"
  [for]="'input_' + name + index"
  [id]="'label_' + name + index"
  #dropdownLabel
  (click)="$event.stopPropagation();"
>
  <input
    class=""
    type="radio"
    [name]="name"
    [id]="'input_' + name + index"
    [hidden]="true"
    (click)="$event.stopPropagation();"
  >

  <div
    (click)="fieldClick(name, index); $event.stopPropagation(); $event.preventDefault()"
    class="dropdown-field"
  >
    <ng-content select="placeholder"/>

    <nb-icon *ngIf="showIcon" class="dropdown-field-icon" icon="chevron-down-outline"/>
  </div>

  <div
    class="options"
    [id]="'options_' + name + index"
    [ngClass]="direction"
  >
    <ng-content select="dropdown">
    </ng-content>
  </div>
</label>
